<aim-sso-login-ui
    (openHome)="openHome()"
    [signingIn]="working" [error]="error" [sessionExpiredMode]="sessionExpiredMode"></aim-sso-login-ui>
